<template>
  <div class="house">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>回收站</el-breadcrumb-item>
          <el-breadcrumb-item>文稿回收站</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div class="head disflex">
        <div class="left">
          <h4 style="font-size:18px;margin-left:5px;">文稿回收站<span style="font-size:13px;font-weight:300;">（{{nnclutteredPic || 0}}张）</span></h4>
        </div>

        <div class="rightpic disflex">
          <span>删除时间：</span>
          <el-date-picker v-model="delTime"
                              type="daterange"
                              align="center"
                              @change="dateChange"
                              value-format="timestamp"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"></el-date-picker>
          <el-button :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" v-if="choosePic.length > 0 && powersObj.recoveryCommand" @click.stop="allRecovery">
            恢复
          </el-button>
          <el-button :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" v-if="choosePic.length > 0 && powersObj.deleteCommand" @click.stop="allDel">
            彻底删除
          </el-button>
          <!-- <p @click="picSortFlag = true"
             :class="picSortFlag === true ? isSimple ? 'simpleactive' : 'active' : ''">按天排序</p>
          <div>|</div>
          <p @click="picSortFlag = false"
             :class="picSortFlag === true ? '' : isSimple ? 'simpleactive' : 'active'">按月排序</p> -->
        </div>
      </div>

      <div v-loading="isDelete"
           class="piclist"
           style="display:flex;">
        <div style="width:100%;min-height:805px;">
          <!-- <div v-if="choosePic.length > 0"
               @click.stop="plDelete"
               class="del">
            <div style="text-align:center;">
              <img src="@/assets/personpic/alldel.png"
                   alt="">
              <p style="margin-left:3px;">删除</p>
            </div>
          </div> -->
          <template v-if="picSortFlag"> 
            <div class="time"
                 v-for="(e,i) in testList"
                 :key="i">
              <el-checkbox @change="choosePicChange(testList[i].time420,e.picList,i)"
                           :indeterminate="testList[i].indeterminate"
                           v-model="testList[i].time420">{{e.mycreateAt}}</el-checkbox>
              <div class="yuan"></div>
              <div class="xian"></div>

              <div class="datepic">
                <section>

                  <div :class="choosePic.indexOf(item.id) === -1 ? 'img-wrapper':isSimple ? 'img-wrapper simpleimgborder' : 'img-wrapper imgborder'"
                       @click="choosePicClick(item.id,i,item.atlasId)"
                       v-for="(item, index) in e.picList"
                       :key="index">
                    <!-- <el-image class="img"
                         @contextmenu.prevent="rightShow($event)"
                         ondragstart="return false;"
                         :src="item.src" >
                         <div slot="error"
                          class="image-slot">
                          <img src="@/assets/house/onloadpicerror.png"
                              alt />
                        </div>
                    </el-image> -->

                    <div class="word">
                      <img src="@/assets/piclist/wordlist.png" alt="">
                      <h3>{{item.title}}</h3>
                      <p>{{item.content}}</p>
                      <div class="read" @click.stop="openWord(item)">
                        <div>阅读详情</div>
                        <img src="@/assets/piclist/you.png" style="margin-left:6px;" alt="">
                      </div>
                    </div>

                    <div class="dian">
                      <img src="@/assets/piclist/dian.png" alt="">
                      <div class="diannr">

                        <p v-if="powersObj.recoveryCommand" @click.stop="recoveryPic(item)">恢复文稿</p>
                        <p v-if="powersObj.deleteCommand" @click.stop="delPic(item)">彻底删除</p>
                      </div>
                    </div>

                    <!-- 修改图片信息 -->
                    <!-- <el-tooltip class="item"
                                effect="dark"
                                content="修改图片说明"
                                placement="top">
                      <div @click.stop="openChangeDesc(item)"
                           class="changedesc">
                        <img src="@/assets/sreenpic/desc.png"
                             alt="">
                      </div>
                    </el-tooltip> -->

                    <!-- 修改图片信息 -->
                    <!-- <el-tooltip class="item"
                                effect="dark"
                                content="查看图片"
                                placement="top">
                      <div @click.stop="seePic(item,index,i)"
                           class="seepic">
                        <img src="@/assets/solicitationactivities/see.png"
                             alt="">
                      </div>
                    </el-tooltip> -->

                    <div v-if="choosePic.indexOf(item.id) !== -1"
                         class="delete">
                      <img :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                           alt="">
                    </div>
                  </div>

                </section>
              </div>
            </div>

          </template>

          <template v-if="!picSortFlag">
            <div class="time"
                 v-for="(e,i) in testListMonth"
                 :key="i">
              <el-checkbox @change="choosePicChange(testList[i].time420,e.picList,i)"
                           :indeterminate="testList[i].indeterminate"
                           v-model="testList[i].time420">{{e.mycreateAtMonth}}</el-checkbox>
              <div class="yuan"></div>
              <div class="xian"
                   style="left:99px;"></div>

              <div class="datepic">
                <section>

                  <div :class="choosePic.indexOf(item.id) === -1 ? 'img-wrapper':isSimple ? 'img-wrapper simpleimgborder' : 'img-wrapper imgborder'"
                       @click="choosePicClick(item.id,i,item.atlasId)"
                       v-for="(item, index) in e.picList"
                       :key="index">
                    <img class="img"
                         @contextmenu.prevent="rightShow($event)"
                         ondragstart="return false;"
                         :src="item.src" />
                    <div v-if="choosePic.indexOf(item.id) !== -1"
                         class="delete">
                      <img :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                           alt="">
                    </div>
                  </div>

                </section>
              </div>
            </div>
          </template>

          <template v-if="testList.length === 0">
            <div class="nopic">
              <img src="@/assets/piclist/nonr.png"
                   alt />
            </div>
          </template>
          <img v-if="showLoading"
               width="200px"
               style="margin-left:40%"
               src="@/assets/blue-preloader.gif"
               alt />
        </div>
      </div>

    </div>
    <div>
      <picviewA ref="picviewA" :picviewlist='picviewlist' />
    </div>
    <!-- 查看未整理图片 -->
    <picview :dialogVisible="picdialogVisible"
             @handleClose="handleClosepic"
             :passChoose='passChoose'
             :picList='inPicList'></picview>

    <!-- 查看文稿内容 -->
    <wordetaildialog @handleClose='wordDialog = false' :dialogVisible='wordDialog' :message="wordContent"></wordetaildialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { searchAtlas } from '@/api/search'
import { deletePicture,recyclePicture,listRecyclePicture } from '@/api/picture'
import { formatConversion } from '@/plugins/getdate'
import { listLib } from "@/api/lib";
import { picPrefix } from "@/constants/piccommon";
import { addAtlas, updateAtlas } from "@/api/atlas";
import { listPeopleFaceByPeopleId } from "@/api/peopleFace";
import { listPeople, setPass, markPeople, getPeopleConstant, mergePeople } from "@/api/people";
import { powersObj, allowLib } from "@/constants/powers";
import picviewA from '@/components/preview/index.vue'
import { selectList,recover,deleteHard,selectInfo } from "@/api/word";
import { wordetaildialog } from '@/components/index'


import picview from '@/components/picView/picView'
export default {
  inject: ['reload'],
  components: { picview,wordetaildialog,picviewA },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      //筛选
      delTime:[],
      timeStart:'',
      timeEnd:'',

      //可见性权限
      statusFlag: false,

      //图集信息
      atlasInfo: null,

      //根据分辨率判断长度
      documentHeight: 0,
      minRows: 8,
      maxRows: 12,


      //权限
      powersObj,
      allowLib,


      //批量操作
      plFlag: true,
picviewlist:'',


      //分辨率
      row: 1,
      widthWithUP: '',
      displayResolution: 0,

      //图集间距
      atlasMargin: '',

      //侧边栏是否收起
      isAside: this.bus.val,

      picPrefix,


      //选中的图片
      choosePic: [],
      chooseAtlasId: [],


      //当日所有的图片
      testList: [],
      //当月所有的图片
      testListMonth: [],

      //存储所有未整理图片
      allPicList: [],

      atlasId: '',
      libId: '',
      isSave: false,

      //是按天还是按月排序   
      picSortFlag: true,
      picinfClass: "picinf",

      //时间排序 
      sortFlag: true,

      //未整理图片的个数
      nnclutteredPic: "",

      currentPage: 0,

      //显示我的图集还是未整理图片   0为图集
      isPic: 0,

      //分页
      total: 0,
      pageSize: 40,
      page: 0,
      totalPic: 0,
      pageSizePic: 10,
      pagePic: 0,
      orderByTime: 0,

      //所有图集
      picList: [],

      faceMarginTop: '',

      isRefresh: false,

      
      isReLoad: false,
      isDelete: false,
      alreadyPicLength: 0,

      //查看图片相关
      atlasName: '新建图集',

      //图片说明
      descdialogVisible: false,
      message: '',

      //查看未整理图片相关
      picdialogVisible: false,
      passChoose: {},
      inPicList: [],
      showLoading: false,
      passFlag: true,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,


      //文档弹窗
      wordContent:'',
      wordDialog:false,
    };
  },
  methods: {

    openWord(e){
      if(e.path){
          if(e.path.indexOf('docx') ==-1){
             this.$message.error('暂不支持doc格式预览');
             return
        }
        if(e.path.indexOf('http') == -1){
        this.picviewlist=this.picPrefix +  e.path
        }else{
         this.picviewlist=e.path
        }
        this.$refs.picviewA.src= this.picviewlist
        this.$refs.picviewA.previewShow=  true
        this.$refs.picviewA.loadFromUrl()
      }else{
        this.selectInfoAsync({id:e.id})
      }
    },

    //检索单个文稿
    async selectInfoAsync(val) {
      let { status, data, message, errors } = await selectInfo(
        val
      );
      if(status){
        this.wordContent = data.content
        this.wordDialog = true
      }
    },

    //时间筛选
    dateChange(){
      if (this.delTime) {
        this.delTime[0] = this.delTime[0];
        this.delTime[1] = this.delTime[1] + 86399000;
        if (this.delTime[0]) {
          this.timeStart = this.delTime[0] / 1000;
          this.timeEnd = this.delTime[1] / 1000;
        }
      } else {
        this.timeStart = "";
        this.timeEnd = "";
      }
      this.isRefresh = true
      this.currentPage = 0
      this.choosePic = []
      this.nnclutteredPic = 0
      this.testList = []
      this.testListMonth = []
      this.listUnclutteredPictureAsync({
            pageNum: this.currentPage,
            pageSize:this.pageSize,
            updateAtMax:this.timeEnd,
            updateAtMin:this.timeStart,
            order:0,
            orderBy:'update',
            isDelete:1
          })

    },

    //批量恢复图片
    allRecovery(){
      this.$confirm("确认恢复这些文稿吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          // console.log(e);
          this.isDelete = true
          for (let i = 0; i < this.choosePic.length; i++) {
            this.recyclePictureAsync({id:this.choosePic[i]},i)
          }
        })
    },

    //批量删除图片
    allDel(){
      this.$confirm("确认彻底删除这些文稿吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          // console.log(e);
          this.isDelete = true
          for (let i = 0; i < this.choosePic.length; i++) {
            this.deletePictureAsync({id:this.choosePic[i]},i)
          }

          
        })
    },

    //单个恢复图片
    recoveryPic(e){
      this.$confirm("确认恢复该文稿吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          // console.log(e);
          this.isDelete = true
          this.recyclePictureOneAsync({id:e.id})
        })
    },
    //单个删除图片
    delPic(e){
      this.$confirm("确认删除该文稿吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.isDelete = true
          this.deletePictureOneAsync({id:e.id})
        })
    },

    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },




    //查看未整理图片
    seePic (e, ci, i) {
      e.createAtMy = e.mycreateAt
      if (e.fileInfo.savepath) {
        e.format = e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3)
      } else {
        e.format = '暂无'
      }
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.passChoose = e
      this.passChoose.myId = ci
      this.inPicList = this.testList[i].picList
      for (let z = 0; z < this.inPicList.length; z++) {
        this.inPicList[z].myId = z
      }
      this.picdialogVisible = true
    },
    handleClosepic () {
      this.picdialogVisible = false
    },


    //查看图集信息
    seeAtlas (e) {
      this.atlasName = '图集信息'
      this.ruleForm = {
        name: e.name,
        region: e.libId || 0,
        desc: e.desc,
        status: e.status,
        id: e.id,
        indexpicId: e.indexpicId,
        sourceType: e.sourceType,
      }
      this.dialogVisiblePutIn = true
      // console.log(e)
    },

    

    changeUploadMode () {
      if (this.uploadMode === 0) {

        this.uploadMode = 1
      } else {
        this.uploadMode = 0
      }
    },



   


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.currentPage = 0
      this.choosePic = []
      this.delTime = []
      this.timeEnd = ''
      this.timeStart = ''

      //获取未整理图片
      this.listUnclutteredPictureAsync({
            pageNum: this.currentPage,
            pageSize:this.pageSize,
            updateAtMax:this.timeEnd,
            updateAtMin:this.timeStart,
            order:0,
            orderBy:'update',
            isDelete:1
          })


      this.displayResolution = document.documentElement.clientWidth;

      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },





    //选择图片
    choosePicClick (id, i,aid) {
      if (this.choosePic.indexOf(id) === -1) {
        this.choosePic.push(id)
        this.chooseAtlasId.push(aid)
        this.testList[i].indeterminate = true
        this.testList[i].chooseFlag++
        if (this.testList[i].chooseFlag === this.testList[i].picList.length) {
          this.testList[i].time420 = true
          this.testList[i].indeterminate = false
        }
      } else {
        this.choosePic.splice(this.choosePic.indexOf(id), 1)
        this.chooseAtlasId.splice(this.chooseAtlasId.indexOf(aid), 1)
        this.testList[i].chooseFlag--

        if (this.testList[i].chooseFlag === 0) {
          this.testList[i].indeterminate = false
          this.testList[i].time420 = false
        } else {
          this.testList[i].indeterminate = true
          this.testList[i].time420 = false
        }
      }
    },

    //选择改变的图片
    choosePicChange (check, pl, index) {
      this.testList[index].indeterminate = false
      if (check) {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) === -1) {
            this.choosePic.push(e.id)
            this.chooseAtlasId.push(e.atlasId)
            this.testList[index].chooseFlag++
          }
        })
      } else {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) !== -1) {
            this.choosePic.splice(this.choosePic.indexOf(e.id), 1)
            this.chooseAtlasId.splice(this.chooseAtlasId.indexOf(e.atlasId), 1)
            this.testList[index].chooseFlag--
          }
        })
      }
    },



    

    //批量删除
    plDelete () {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.isSave = true
          this.isDelete = true
          for (let i = 0; i < this.choosePic.length; i++) {
            this.deletePictureAsync(this.choosePic[i])
          }

          setTimeout(() => {
            this.allPicList = []
            this.testList = []
            this.testListMonth = []
            this.choosePic = []
            this.nnclutteredPic = 0
            this.listUnclutteredPictureAsync({
              pageNum: this.currentPage,
              pageSize:this.pageSize,
              updateAtMax:this.timeEnd,
              updateAtMin:this.timeStart,
              order:0,
            orderBy:'update',
              isDelete:1
            })
            this.isSave = false
            this.isDelete = false
          }, 1000);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },


    //滚动加载图库和图片
    scrollPic () {
      // let isBottom = (document.documentElement.scrollTop + window.innerHeight) === document.body.offsetHeight

      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;

      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      // this.pic.id = scrollTop
      if (isBottom) {
        // if (this.isPic === 0) {

        // } else if (this.isPic === 1) {
        let allLength = 0
        for (let i = 0; i < this.testList.length; i++) {
          allLength += this.testList[i].picList.length
        }
        if (allLength < this.nnclutteredPic && this.passFlag) {
          this.currentPage++;
          let params = {
            pageNum: this.currentPage,
            pageSize:this.pageSize,
            updateAtMax:this.timeEnd,
            updateAtMin:this.timeStart,
            order:0,
            orderBy:'update',
            isDelete:1
          };
          this.showLoading = true
          setTimeout(() => {
            this.listUnclutteredPictureAsync(params);
          }, 1000);
        }
        // } else if (this.isPic == 2) {

        // }


      }
    },


    //把接口返回的json转换成数组---按日期
    dealWithData (data) {
      let c = [];
      let d = {};
      data.forEach(element => {
        if (!d[element.mycreateAt]) {
          c.push({
            time420: false,
            indeterminate: false,
            chooseFlag: 0,
            mycreateAt: element.mycreateAt,
            picList: [element]
          });
          d[element.mycreateAt] = element;
        } else {
          c.forEach(ele => {
            if (ele.mycreateAt == element.mycreateAt) {
              ele.picList.push(element);
            }
          });
        }

      });
      return c;
    },

    //把接口返回的json转换成数组---按月份
    dealWithMonth (data) {
      let c = [];
      let d = {};
      data.forEach(element => {
        if (!d[element.mycreateAtMonth]) {
          c.push({
            time420: false,
            indeterminate: false,
            chooseFlag: 0,
            mycreateAtMonth: element.mycreateAtMonth,
            picList: [element]
          });
          d[element.mycreateAtMonth] = element;
        } else {
          c.forEach(ele => {
            if (ele.mycreateAtMonth == element.mycreateAtMonth) {
              ele.picList.push(element);
            }
          });
        }

      });
      return c;
    },


    unclutter () {

      if (this.isPic !== 1) {
        this.nnclutteredPic = 0
        this.testList = []
        this.testListMonth = []
        this.currentPage = 0
        this.listUnclutteredPictureAsync({
            pageNum: this.currentPage,
            pageSize:this.pageSize,
            updateAtMax:this.timeEnd,
            updateAtMin:this.timeStart,
            order:0,
            orderBy:'update',
            isDelete:1
          })
      }

      setTimeout(() => {
        this.isPic = 1
      }, 200);
    },

    async deletePictureOneAsync (val) {
      let {status, data, message} = await deleteHard(val)
      if(status){
        this.$message.success('删除成功！')
        this.isDelete = false
        this.refresh()
      }else{
        this.$message.error('删除失败！')
        this.isDelete = false
      }
    },
    async recyclePictureOneAsync (val) {
      let {status, data, message} = await recover(val)
      if(status){
        this.$message.success('恢复成功！')
        this.isDelete = false
        this.refresh()
      }else{
        this.$message.error('恢复失败！')
        this.isDelete = false
      }
    },
    async recyclePictureAsync (val,i) {
      await recover(val)
      if(i == this.choosePic.length - 1){
        this.isDelete = false
        this.$message.success('恢复成功！')
        this.refresh()
      }
    },

    async deletePictureAsync (val,i) {
      await deleteHard(val)
      if(i == this.choosePic.length - 1){
        this.isDelete = false
        this.$message.success('删除成功！')
        this.refresh()
      }
    },




    //获取未整理图片
    async listUnclutteredPictureAsync (val) {
      let { status, data, message, pagination, errors } = await selectList(val);
      this.isRefresh = false
      if (status) {
        this.nnclutteredPic = pagination.total
        for (let i = 0; i < data.length; i++) {
          data[i].isUpload = false
          if(data[i].path){
            data[i].isUpload = true
          }

          if (data[i].createAt !== 0) {
            data[i].mycreateAt = formatConversion(data[i].updateAt.toString()).substring(0, 10)
          } else {
            data[i].mycreateAt = '暂无创建时间'
          }
          if (data[i].createAt !== 0) {
            data[i].mycreateAtMonth = formatConversion(data[i].updateAt.toString()).substring(0, 7)
          } else {
            data[i].mycreateAtMonth = '暂无创建时间'
          }

          data[i].picSrc = ''
          if(data[i].pictureList.length > 0){
            data[i].picSrc = this.picPrefix + data[i].pictureList[0].levelPath
          }

          data[i].content = data[i].content.trim()
          var reg = new RegExp("/n","");
          data[i].content = data[i].content.replace(reg,"");
        }
        // this.testList = this.dealWithData(data)
        // this.testListMonth = this.dealWithMonth(data)


        if (this.currentPage === 0) {
          this.testList = this.dealWithData(data)
          this.testListMonth = this.dealWithMonth(data)
          this.allPicList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.allPicList.push(data[i])
          }
          this.testList = this.dealWithData(this.allPicList)
          this.testListMonth = this.dealWithMonth(this.allPicList)


          // let date = this.dealWithData(data)
          // for (let i = 0; i < date.length; i++) {
          //   this.testList.push(date[i]);
          // }
          // let month = this.dealWithMonth(data)
          // for (let i = 0; i < month.length; i++) {
          //   this.testListMonth.push(month[i]);
          // }
        }

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
      this.showLoading = false
      this.passFlag = true
    },




    //判断分辨率
    judgRes () {
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px"
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px"
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px"
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px"
      }
    },

    //判断gril的row值
    checkRow () {
      this.displayResolution = document.documentElement.clientWidth;
      if (this.displayResolution > 2800) {
        this.row = 9
        this.widthWithUP = "13%"
        this.faceRow = 8
        this.widthWithUPFace = '23.5%'
      } else
        if (this.displayResolution > 2700) {
          this.row = 8
          this.widthWithUP = "13%"
          this.faceRow = 7
          this.widthWithUPFace = '23.5%'
        } else
          if (this.displayResolution > 2500) {
            this.row = 7
            this.widthWithUP = "13%"
            this.faceRow = 6
            this.widthWithUPFace = '23.5%'
          } else
            if (this.displayResolution > 2400) {
              this.row = 6
              this.widthWithUP = "14%"
              this.faceRow = 5
              this.widthWithUPFace = '23.5%'
            } else
              if (this.displayResolution > 2000) {
                this.row = 5
                this.widthWithUP = "16%"
                this.faceRow = 4
                this.widthWithUPFace = '23.5%'
              } else

                if (this.displayResolution > 1700) {
                  this.row = 5
                  this.widthWithUP = "18%"
                  this.faceRow = 4
                  this.widthWithUPFace = '23.5%'
                }
      if (this.displayResolution <= 1700) {
        this.row = 4
        this.widthWithUP = "21.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1600) {
        this.row = 4
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1550) {
        this.row = 3
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1400) {
        this.row = 3
        this.widthWithUP = "25%"
        this.faceRow = 2
        this.widthWithUPFace = '25%'
      }
    }





  },
  created () {
    this.isRefresh = true


    //获取未整理图片
    this.listUnclutteredPictureAsync({
            pageNum: this.currentPage,
            pageSize:this.pageSize,
            updateAtMax:this.timeEnd,
            updateAtMin:this.timeStart,
            order:0,
            orderBy:'update',
            isDelete:1
    })

    

    this.displayResolution = document.documentElement.clientWidth;

    this.documentHeight = document.documentElement.clientHeight

    if (this.documentHeight <= 650) {
      this.minRows = 0
      this.maxRows = 1
    } else if (this.documentHeight <= 775) {
      this.minRows = 4
      this.maxRows = 8
    } else if (this.documentHeight <= 970) {
      this.minRows = 8
      this.maxRows = 12
    }




  },
  mounted () {
    window.addEventListener("scroll", this.scrollPic);
    //获取侧边栏是否收起
    this.bus.$on('changeIsaside', (message) => {
      this.bus.val = message
      this.isAside = this.bus.val
      // this.isChildren = false
    })
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./recycleWord.scss";

/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
/deep/ ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
/deep/ ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}

.el-table /deep/ .el-table__body tr td {
  cursor: pointer;
}
.el-table /deep/ .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table /deep/ .el-table__body .current-row td .cell {
  color: #fff !important;
}

// .el-radio-group /deep/ .is-active .el-radio-button__inner {
//   background: #185ed3;
//   border-color: #185ed3;
// }
.seeInfo {
  background: #f2f2f2 !important;
  border: 1px solid rgba(119, 119, 119, 0.1);
  color: #333333;
  margin-right: -40px;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3CB035;
  border-color: #3CB035;
}
</style>
